<template>
  <div id="users" class="users">
    <div
      :id="'users_' + type"
      style="overflow-y: auto"
      v-resize="onResizeUserList"
      :style="{ height: userListHeight + 'px' }"
      @scroll="onUserScroll"
    >
      <div :id="'users_' + type + '_container'">
        <v-layout justify-center column fill-height v-if="userloading || usersearching">
          <div class="text-xs-center mt-4 mb-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-layout>
        <template v-else-if="livechatUsers(type) && livechatUsers(type).length > 0">
          <!-- {{ sortedUsers }} -->
          <div
            v-for="(user, index) in sortedUsers"
            :key="'user-' + index + '-' + user.userid"
            @click="selectUser(user)"
            class="user"
          >
            <user-item
              v-model="livechatUsers(type)[index]"
              :selected="selectedUser != null && user.userid == selectedUser.userid"
              :key="livechatUsers(type)[index].userid"
            ></user-item>
            <v-divider></v-divider>
          </div>
          <!-- <div
            v-if="loadmore"
            class="text-xs-center"
            style="background:#eee;padding-top:10px;padding-bottom:10px"
          >
            <v-progress-circular indeterminate color="grey" small class="mr-2" :width="2"></v-progress-circular>Loading
          </div>-->
          <template v-if="isMobile">
            <div
              class="text-xs-center"
              style="background: #eee; padding-top: 10px; padding-bottom: 10px"
              @click="onLoadmore"
            >
              <template v-if="loadmore">
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </template>
              <template v-else @click="onLoadmore">Click to load more conversation</template>
            </div>
          </template>
          <template v-else>
            <div
              v-if="loadmore"
              class="text-xs-center"
              style="background: #eee; padding-top: 10px; padding-bottom: 10px"
            >
              <v-progress-circular
                indeterminate
                color="grey"
                small
                class="mr-2"
                :width="2"
              ></v-progress-circular
              >Loading
            </div>
          </template>
        </template>
        <v-layout justify-center column fill-height v-else>
          <div class="text-xs-center mt-4 mb-4">
            <img src="/static/img/assets/livechat/no_user.png" alt />
            <div>No users</div>
          </div>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userItem from './livechat-user-item'
import api from '@/api'

export default {
  props: ['value', 'type', 'app', 'filter', 'isMobile', 'usersearching'],
  data: function () {
    return {
      view_ticket: '',
      loading: true,
      userloading: true,
      maxTime: 15000,
      timer: '',
      windowHeight: 0,
      userListHeight: 0,
      limit: 20,
      offset: 0,
      users: [],
      isAutoRefresh: true,
      loadmore: false
      // filter: {},
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      livechatUsers: 'getLivechatUsers',
      selectedUser: 'getCurrentUser',
      searchlist: 'getLivechatSearching',
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    }),
    currentTheme() {
      return this.$store.state.livechat.theme
        ? this.$store.state.livechat.theme
        : this.selectedBot.theme
    },
    sortedUsers: function () {
      var vm = this
      var users = []
      users = vm.livechatUsers(vm.type).sort(function (a, b) {
        return new Date(b.lastreply_time) - new Date(a.lastreply_time)
      })
      return users
    }
  },
  components: {
    'user-item': userItem
  },
  created: function () {
    let vm = this

    vm.timer = setInterval(() => {
      vm.$store.dispatch('loadLatestUsers', {
        type: vm.type
      })
    }, vm.$store.getters.getLivechatDetail('maxFetchUserTime'))
  },
  mounted: async function () {
    let vm = this
    vm.userloading = true
    if (
      vm.selectedBot.theme == 'ticket' ||
      vm.$store.state.ticketPageid.includes(vm.selectedBot.pageid)
    ) {
      await vm.initTicket()
      vm.initFilter()
    }

    // this.$root.$on('loadLivechatUser', () => {
    //   vm.$store.dispatch('loadLivechatUsers', {
    //     type: vm.type
    //   })
    // })

    // Refresh user list every 30 sec
    // Only KFC
    // if (this.selectedBot.pageid === '106855151601601') {
    //   setInterval(() => {
    //     vm.$store.dispatch('loadLivechatUsers', {
    //       type: vm.type
    //     })
    //   }, 30000)
    // }

    try {
      vm.$set(vm.$store.state.livechat, 'app', vm.app)

      // Refresh user list every 30 sec
      // Only KFC
      if (this.selectedBot.pageid === '106855151601601') {
        // setInterval(() => {
        //   vm.$store.dispatch('loadLivechatUsers', {
        //     type: vm.type
        //   })
        // }, 30000)
      } else {
        await vm.$store.dispatch('loadLatestUsers', {
          type: vm.type
        })
      }

      vm.userloading = false
      vm.onResizeUserList()
    } catch (error) {
      console.log(error)
      vm.userloading = false
      vm.$swal.fire({
        title: 'Load failed',
        // title: error,
        type: 'error',
        confirmButtonText: vm.$t('Confirm')
      })
    }
  },
  methods: {
    initTicket() {
      return new Promise(async (resolve) => {
        await this.$store.dispatch('loadAgents')
        await this.$store.dispatch('loadAgentGroups')
        await this.$store.dispatch('loadAgentSubGroups')
        resolve()
      })
    },
    onUserScroll: async function () {
      var vm = this
      if (vm.isMobile) {
        return false
      }
      let messages = $('#users_' + vm.type)
      let scrollPosition = messages.scrollTop()
      let chatboxHeight = messages.outerHeight(true)
      let totalHeight = messages.prop('scrollHeight')

      if (scrollPosition <= chatboxHeight) {
        vm.enableAutoUpdate(true)
      }
      if (Math.abs(Math.round(scrollPosition + chatboxHeight) - totalHeight) < 3) {
        vm.enableAutoUpdate(false)
        await vm.onLoadmore()
      }
    },
    enableAutoUpdate: function (enable) {
      this.$set(this.$store.state.livechat.userlist[this.type], 'isAutoRefresh', enable)
    },
    onResizeUserList: function () {
      var vm = this
      vm.$nextTick(function () {
        if (document.getElementById('chattype')) {
          vm.userListHeight =
            window.innerHeight -
            document.getElementById('main_toolbar').clientHeight -
            document.getElementById('chattype').clientHeight -
            5
        }
      })
    },
    selectUser: async function (user) {
      this.$store.commit('SET_LIVECHAT_USER', null)
      await this.$nextTick()
      user.type = this.type
      this.$store.commit('SET_LIVECHAT_USER', user)

      this.$emit('onClickUser')
      if (true) {
        api.adminreadchat(
          {
            adminid: this.$store.state.userid,
            userid: user.userid,
            pageid: this.selectedBot.pageid
          },
          () => {
            var vm = this
            vm.$nextTick(() => {
              user.adminread = true
              vm.$store.commit('SET_LIVECHAT_USER', user)
              vm.$forceUpdate()
              vm.$store.dispatch('livechatnotiunread').then((val) => {})
            })
          }
        )
      }
    },
    getLatestChatUsers: function () {
      var vm = this
      if (vm.loading) {
        return false
      }
      let limit = 20
      if (vm.livechatUsers(vm.type).length == 0) {
        limit = 20
      }

      vm.getLiveChatUsers(0, limit, true).then(
        function (users) {
          vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: users })
        },
        function (error) {
          // console.log(error)
        }
      )
    },
    initFilter() {
      var admingroupid = this.$store.state.admingroupid
      var adminsubgroupid = this.$store.state.adminsubgroupid
      var filter = {}
      var group = {}
      var subgroup = {}

      this.agentGroup.map((el) => {
        group[el.id] = el
      })
      this.agentSubGroup.map((el) => {
        subgroup[el.id] = el
      })

      // var group = this.agentGroup
      this.view_ticket = this.$store.state.privilege.view_ticket
      if (this.view_ticket == 'all') {
        // dont do shit
      } else if (this.view_ticket == 'only_me') {
        this.filter.assignadminid = this.$store.state.userid
        Object.assign(filter, {
          assignadminid: this.$store.state.userid
        })
        if (admingroupid || admingroupid === 0) {
          this.filter.assigngroupid = group[admingroupid].id
        }
        if (adminsubgroupid || adminsubgroupid === 0) {
          this.filter.assignsubgroupid = subgroup[adminsubgroupid].id
        }
        if (this.agents) {
          this.filter.admin = this.agents.find((el) => el.adminid == this.$store.state.userid)
        }
      } else if (this.view_ticket == 'only_group') {
        Object.assign(filter, {
          assigngroupid: admingroupid
        })

        if (admingroupid || admingroupid === 0) {
          this.filter.assigngroupid = group[admingroupid].id
        }
      } else if (this.view_ticket == 'only_subgroup') {
        Object.assign(filter, {
          assignsubgroupid: adminsubgroupid
        })
        if (admingroupid || admingroupid === 0) {
          this.filter.assigngroupid = group[admingroupid].id
        }
        if (adminsubgroupid || adminsubgroupid === 0) {
          this.filter.assignsubgroupid = subgroup[adminsubgroupid].id
        }
      }
    },
    getLiveChatUsers: function (offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        vm.loading = true
        let data = {
          pageid: vm.$store.state.livechat.pageid || vm.selectedBot.pageid,
          offset: offset,
          limit: limit,
          inbox: vm.type,
          app: vm.app,
          ...vm.filter
        }
        if (vm.currentTheme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            data.uu_areaname = vm.selectedBot.uu_areaname
          } else if (vm.filter.uuAreaName != '') {
            data.uu_areaname = vm.filter.uuAreaName
          }
          if (vm.filter.lineid) {
            data.lineid = vm.filter.lineid
          }
          if (vm.filter.uu_register_status) {
            data.uu_register_status = vm.filter.uu_register_status
          }
          if (vm.filter.lastconversationfrom) {
            data.lastconversationfrom = vm.filter.lastconversationfrom
          }
          if (vm.filter.lastconversationto) {
            data.lastconversationto = vm.filter.lastconversationto
          }
        }

        api.getLiveChatUsers(data, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.loading = false
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    matchChatboxHeight: function () {
      let vm = this
      let totalHeight = vm.windowHeight
      let headerHeight = $('header').outerHeight(true)
      let typeHeight = $('#chattype').outerHeight(true)
      totalHeight = totalHeight - headerHeight - typeHeight
      $('.users').height(totalHeight)
    },
    onLoadmore: async function () {
      var vm = this
      if (vm.loadmore || !vm.$store.state.livechat.userlist[vm.type].hasMore) {
        return false
      }
      vm.loadmore = true

      vm.$set(
        vm.$store.state.livechat.userlist[vm.type],
        'limit',
        vm.$store.state.livechat.userlist[vm.type].limit + vm.$store.state.livechat.limitFatchUser
      )

      try {
        await vm.$store.dispatch('loadLivechatUsers', {
          type: vm.type
        })
        vm.loadmore = false
      } catch (error) {}
    }
  },
  watch: {
    searchlist(newVal, oldVal) {
      if (newVal != oldVal) {
        this.onResizeUserList()
      }
    },
    type: async function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type
          })
          vm.userloading = false
        } catch (error) {}
      }
    },
    app: async function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$set(vm.$store.state.livechat, 'app', newVal)
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type
          })
          vm.userloading = false
        } catch (error) {}
      }
    },
    selectedBot: async function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type
          })
          vm.userloading = false
        } catch (error) {}
      }
    }
    // filter: {
    //   handler: async function(newVal, oldVal) {
    //     let vm = this
    //     if (newVal != oldVal) {
    //       // vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
    //       // vm.userloading = true
    //       // try {
    //       //   await vm.$store.dispatch('loadLivechatUsers', {
    //       //     type: vm.type
    //       //   })
    //       //   vm.userloading = false
    //       // } catch (error) {}
    //       vm.onResizeUserList()
    //     }
    //   },
    //   deep: true
    // },
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.user {
  cursor: pointer;
  &:hover {
    background: #eee;
  }

  &:active {
    background: rgb(245, 244, 244);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-users.vue